import { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import dayjs from 'dayjs';

// Default Languages to customize according to the App
import en from 'dayjs/locale/en';
// import fr from 'dayjs/locale/fr';
// import ar from 'dayjs/locale/ar';

import enAntD from 'antd/locale/en_US';
// import frAntD from 'antd/locale/fr_FR';
// import arAntD from 'antd/locale/ar_EG';


const getDayjsLocale = (languageCode: string) => {
  switch (languageCode.toLowerCase()) {
    case 'en':
    case 'en-gb':
    case 'en-us':
      return en;
    // case 'fr':
    // case 'fr-fr':
    // case 'fr-ca':
    //   return fr;
    // case 'ar':
    // case 'ar-eg':
    //   return ar;
    default:
      return en;
  }
};

const getAntdLocale = (languageCode: string) => {
  switch (languageCode.toLowerCase()) {
    case 'en':
    case 'en-gb':
    case 'en-us':
      return enAntD;
    // case 'fr':
    // case 'fr-fr':
    // case 'fr-ca':
    //   return frAntD;
    // case 'ar':
    // case 'ar-eg':
    //   return arAntD;
    default:
      return enAntD;
  }
};

export default function useInternationalization() {
  const {
    i18n: { language },
  } = useTranslation();

  const [antdLocale, setAntdLocale] = useState(enAntD);

  // Set Dayjs and AntD Locales based on i18n global App Language
  useEffect(() => {
    dayjs.locale(getDayjsLocale(language));
    setAntdLocale(getAntdLocale(language));
  }, [language]);

  return { language, antdLocale };
}
